import { render, staticRenderFns } from "./AamsGiftRegOutStorageReturn.vue?vue&type=template&id=12582624&scoped=true&"
import script from "./AamsGiftRegOutStorageReturn.vue?vue&type=script&lang=js&"
export * from "./AamsGiftRegOutStorageReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12582624",
  null
  
)

export default component.exports